import {ConversionDataTypes, dataConverterBlock} from "@/state/features/types";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {convertJsonToSomething, convertToJSON} from "@/lib/conversion";


const initialState: dataConverterBlock = {
    originalText: "",
    JSONTruth: "",
    originalTextType: ConversionDataTypes.YAML,
    convertedText: "",
    convertedTextType: ConversionDataTypes.JSON
};



export const dataConversionSlice = createSlice({
    name: 'dataConverter',
    initialState,
    reducers: {
        convert: function (state, action: PayloadAction<{originalText: string, originalTextType: ConversionDataTypes, convertedTextType: ConversionDataTypes}>) {
            const {payload} = action;
            const jsonText = convertToJSON(payload.originalText, payload.originalTextType)
            if(!!jsonText  && jsonText ){
                state.JSONTruth = jsonText;
                state.convertedText = convertJsonToSomething(jsonText, payload.convertedTextType)
                state.convertedTextType = payload.convertedTextType;
            }

        }

    },
    extraReducers: (builder) => {
    },
});

const conversionReducer = dataConversionSlice.reducer;
export const { convert } = dataConversionSlice.actions;

export default conversionReducer;
